import { styled } from '@mui/material/styles';
import MuiTableRow from '@mui/material/TableRow';

const TableRow = styled(MuiTableRow)(() => ({
    '&:nth-of-type(odd)': {
        backgroundColor: '#EFF1EC',
    },
}));

export default TableRow;